(() => {
  if (window.PgQtyBundle) {
    window.PgQtyBundle.initAll();
    return;
  }

  const init = (root) => {
    if (root.dataset.pgQtyBundleReady === 'true') return;

    const sectionId = root.dataset.sectionId;
    const form = document.getElementById(root.dataset.productFormId);
    const submitLabel = form?.querySelector('.product-form__submit > span:first-child');
    const liveRegion = root.querySelector('[data-pg-qty-bundle-live]');
    const choices = Array.from(root.querySelectorAll('input[data-pg-qty-choice]'));
    const packSize = parseInt(root.dataset.stufe, 10);

    if (!form || !submitLabel || choices.length !== 2 || !(packSize >= 2)) return;

    // Das Mengenfeld steht im Theme außerhalb des Formulars (form="product-form-…").
    let quantityInput =
      document.getElementById(`Quantity-${sectionId}`) ||
      form.elements.namedItem('quantity') ||
      root.closest('product-info')?.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      // Template ohne Mengenauswahl: verstecktes Feld, damit das Pack mit Menge k in den Warenkorb geht.
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.value = '1';
      form.appendChild(quantityInput);
    }

    root.dataset.pgQtyBundleReady = 'true';

    // Rabattcode-Hinweis zur Fußnote „spare r %*“: direkt unter den Warenkorb-Button (ohne Script bleibt er im Block).
    const footnote = root.querySelector('[data-pg-qty-bundle-fussnote]');
    const submitButton = submitLabel.closest('.product-form__submit');
    if (footnote && submitButton) submitButton.after(footnote);
    const originalSubmitText = submitLabel.textContent.trim();
    let settingQuantity = false;
    let packs = 1;

    // Pack-Zähler (Spec E13): Bei gewähltem Pack zählt das sichtbare Feld Packs statt Stück, damit „4“ nicht als
    // „4 × 4er-Pack“ gelesen wird. Er steht an der Stelle des Dawn-Mengenfelds, übernimmt dessen Klassen und Icons
    // und schreibt Packs × k in das echte Feld. Ohne sichtbares Mengenfeld (Template ohne Block) bleibt es bei 1 Pack.
    const quantityElement = quantityInput.closest('quantity-input');
    let counter = null;
    let counterValue = null;
    const stepButtons = {};
    if (quantityElement) {
      counter = document.createElement('div');
      counter.className = `${quantityElement.className} pg-qty-packs`;
      counter.dataset.pgQtyPacks = '';
      counter.setAttribute('role', 'group');
      counter.setAttribute('aria-label', 'Anzahl Packs');
      counter.hidden = true;
      const stepButton = (step, name, label) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'quantity__button';
        button.dataset.pgQtyPacksStep = String(step);
        button.setAttribute('aria-label', label);
        const icon = quantityElement.querySelector(`button[name="${name}"] svg`);
        if (icon) button.appendChild(icon.cloneNode(true));
        else button.textContent = step < 0 ? '−' : '+';
        button.addEventListener('click', () => setPacks(packs + step));
        stepButtons[step] = button;
        return button;
      };
      counterValue = document.createElement('span');
      counterValue.className = 'quantity__input pg-qty-packs__value';
      counterValue.dataset.pgQtyPacksValue = '';
      counter.append(stepButton(-1, 'minus', 'Ein Pack weniger'), counterValue, stepButton(1, 'plus', 'Ein Pack mehr'));
      quantityElement.insertAdjacentElement('afterend', counter);
    }

    // Obergrenze der Variante (max, von Dawn je nach Warenkorb nachgeführt) in ganzen Packs.
    const maxPacks = () => {
      const max = parseInt(quantityInput.max, 10);
      return max >= packSize ? Math.floor(max / packSize) : Infinity;
    };

    const packLabel = () => (packs > 1 ? `${packs} × ${root.dataset.packLabel}` : root.dataset.packLabel);

    const renderPacks = () => {
      if (!counter) return;
      counterValue.innerHTML = '';
      const count = document.createElement('span');
      count.className = 'pg-qty-packs__count';
      count.textContent = `${packs} ${packs === 1 ? 'Pack' : 'Packs'}`;
      const items = document.createElement('span');
      items.className = 'pg-qty-packs__items';
      items.textContent = `${packs * packSize} Stück`;
      counterValue.append(count, ' ', items);
      stepButtons[-1].disabled = packs <= 1;
      stepButtons[1].disabled = packs >= maxPacks();
    };

    const writeQuantity = (quantity) => {
      if (quantityInput.value === quantity) return;
      quantityInput.value = quantity;
      settingQuantity = true;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      settingQuantity = false;
    };

    const announce = (text) => {
      if (!liveRegion) return;
      liveRegion.textContent = '';
      window.requestAnimationFrame(() => {
        liveRegion.textContent = text;
      });
    };

    const markSelection = (choice) => {
      const usePack = choice === 'pack';
      choices.forEach((input) => {
        input.checked = input.value === choice;
      });
      submitLabel.textContent = usePack ? packLabel() : originalSubmitText;
      root.dataset.pgQtyBundleSelection = choice;
      if (counter) {
        quantityElement.hidden = usePack;
        counter.hidden = !usePack;
        renderPacks();
      }
    };

    const setPacks = (value) => {
      packs = Math.max(1, Math.min(value, maxPacks()));
      writeQuantity(String(packs * packSize));
      markSelection('pack');
      announce(`${packs} ${packs === 1 ? 'Pack' : 'Packs'}, ${packs * packSize} Stück`);
    };

    const select = (choice, shouldAnnounce = true) => {
      const usePack = choice === 'pack';
      packs = 1;
      markSelection(choice);
      writeQuantity(String(usePack ? packSize : 1));
      if (shouldAnnounce) announce(usePack ? root.dataset.packAnnouncement : root.dataset.singleAnnouncement);
    };

    root.addEventListener('change', (event) => {
      if (event.target.matches('input[data-pg-qty-choice]') && event.target.checked) {
        select(event.target.value);
      }
    });

    // Menge weg von Packs × k (z. B. Dawn-Rücksetzung): Pack-Wahl aufheben, die gesetzte Menge bleibt stehen.
    const syncWithQuantity = () => {
      if (settingQuantity || root.dataset.pgQtyBundleSelection !== 'pack') return;
      if (parseInt(quantityInput.value, 10) !== packs * packSize) markSelection('single');
    };
    quantityInput.addEventListener('change', syncWithQuantity);

    // Dawn setzt die Menge nach dem Warenkorb still zurück (product-info.js setQuantityBoundries) und meldet das
    // nur über quantityUpdate.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.quantityUpdate, syncWithQuantity);
    }

    // Absenden mit gewähltem Pack geht immer mit Packs × k. Capture am Dokument läuft sicher vor Dawns
    // Submit-Handler am Formular, der die Formulardaten sofort (synchron) liest.
    // Mit Pack-Produkt (data-pack-variant, E22): stattdessen n × die Pack-Variante; danach Variante und Menge zurück.
    const packVariant = root.dataset.packVariant;
    const variantInput = form.querySelector('input[name="id"]');
    document.addEventListener(
      'submit',
      (event) => {
        if (event.target !== form || root.dataset.pgQtyBundleSelection !== 'pack') return;
        if (packVariant && variantInput) {
          const singleVariant = variantInput.value;
          variantInput.value = packVariant;
          quantityInput.value = String(packs);
          window.setTimeout(() => {
            variantInput.value = singleVariant;
            quantityInput.value = String(packs * packSize);
          }, 0);
        } else {
          quantityInput.value = String(packs * packSize);
        }
      },
      true
    );

    const restored = choices.find((input) => input.checked && input.value === 'pack');
    const restoredQuantity = parseInt(quantityInput.value, 10);
    if (restored && restoredQuantity >= packSize && restoredQuantity % packSize === 0) {
      packs = restoredQuantity / packSize;
      markSelection('pack');
    } else {
      select('single', false);
    }
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-pg-qty-bundle]').forEach(init);
  };

  window.PgQtyBundle = { initAll };
  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
